import swal from 'sweetalert2';

export default {
	methods: {
		showSwal(type) {
			if (type === 'fail') {
				swal.fire({
					title: this.$t('fail'),
					text: this.$t('failMessage'),
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-warning',
					icon: 'warning',
					customClass: {
						popup: 'notification-popup',
					},
				});
			}
			if (type === 'success') {
				swal.fire({
					title: this.$t('success'),
					text: this.$t('successMessage'),
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-success',
					icon: 'success',
					customClass: {
						popup: 'notification-popup',
					},
				});
			}
		},

		showConfirmSwal({ title, text, yesButton, noButton }, confirmCallBack, dismissCallBack) {
			const swalWithBootstrapButtons = swal.mixin({
				customClass: {
					confirmButton: 'btn btn-success',
					cancelButton: 'btn btn-danger',
				},
				buttonsStyling: false,
			});

			swalWithBootstrapButtons
				.fire({
					title: title,
					text: text,
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: yesButton,
					cancelButtonText: noButton,
					reverseButtons: false,
				})
				.then((result) => {
					if (result.isConfirmed) {
						confirmCallBack();
					} else if (
						/* Read more about handling dismissals below */
						result.dismiss === Swal.DismissReason.cancel
					) {
						dismissCallBack();
					}
				});
		},
	},
};
